import React, { useState, Fragment } from 'react'
import {
  InputText,
  Span,
  Button,
  DatePicker,
  InputButton,
  RadioGroup
} from '@pcln/horizon'
import type { DateRange } from 'react-day-picker'
import { RadioPropItems as items } from './constants'
import {
  getFormContainerClass,
  getGridContainerClass,
  getInputClass
} from './HorizonMultiHotelForm.variants'

type MultiHotelFormProps = {
  radioValue: string
  setRadioValue: (value: string) => void
}

export default function MultiHotelForm({
  radioValue,
  setRadioValue
}: MultiHotelFormProps) {
  const [count, setCount] = useState(1)

  const handleAddHotel = () => setCount(prev => prev + 1)
  const removeHotel = () => count > 1 && setCount(prev => prev - 1)

  const handleRadioChange = (value: unknown) => {
    setRadioValue(value as string)
  }

  const onCalendarChange = (
    dates: Date | Date[] | DateRange | undefined
  ): void => {
    // eslint-disable-next-line no-console
    console.log('clicked', dates)
  }

  const hotelType = 'MH'
  const addFlights = false

  return (
    <div className={getFormContainerClass(hotelType, addFlights)}>
      <div className={getGridContainerClass(hotelType, addFlights)}>
        <div className={getInputClass('radio', hotelType, addFlights)}>
          <RadioGroup
            className="flex flex-row justify-start"
            name="hotelType"
            options={items}
            value={radioValue}
            required
            aria-labelledby="trip-type"
            handleChange={handleRadioChange}
          />
        </div>

        <div
          className={getInputClass('repeatFormControls', hotelType, addFlights)}
        >
          <div className={getInputClass('hotelMulti', hotelType, addFlights)}>
            {Array.from({ length: count }).map((_, index) => (
              <Fragment key={`hotel-${index + 1}`}>
                <div className="w-full">
                  <div className="flex flex-row items-center justify-start gap-2 w-full mb-2">
                    <Span>Hotel {index + 1}</Span>
                    {index > 0 && (
                      <Button
                        onClick={removeHotel}
                        type="tertiary"
                        className="my-2"
                      >
                        Remove
                      </Button>
                    )}
                  </div>
                  <div className="flex gap-4 w-auto">
                    <InputText
                      className="w-auto"
                      label="Hotel"
                      isLabelHidden
                      iconLeft="search"
                      placeholder="Where to?"
                    />
                    <div className="w-auto">
                      <DatePicker
                        className="w-auto"
                        title="Hotels: Check-in - Check-out"
                        label="Check-in - Check-out"
                        mode="range"
                        numberOfMonths={2}
                        handleCalendarChange={onCalendarChange}
                      />
                    </div>
                  </div>
                </div>
              </Fragment>
            ))}
          </div>
        </div>

        <Button
          className={getInputClass('addHotelButton', hotelType, addFlights)}
          onClick={handleAddHotel}
        >
          Add another hotel
        </Button>

        <div
          className={getInputClass(
            'travelersSubmitContainer',
            hotelType,
            addFlights
          )}
        >
          <InputButton
            label="Travelers"
            iconLeft="person"
            isLabelHidden
            placeholder="Travelers"
            className={getInputClass('travelers', hotelType, addFlights)}
          />
          <Button
            type="primary"
            className={getInputClass('submit', hotelType, addFlights)}
          >
            Search
          </Button>
        </div>
      </div>
    </div>
  )
}
